import { IonButton, IonContent, IonFooter, IonItem } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { RouteProps } from "react-router";
import firebaseEventConfig from "../../../utils/firebaseAnalytics/firebaseEventConfig";
import { CMEDfirebaseLogEvent } from "../../../utils/firebaseAnalytics/firebaseUtils";
import { CMEDPermissions } from "../MarketData/MarketDataContent";
import OptionsGrid from "./OptionsGrid";
import OptionsGridForm from "./OptionsGridForm";
import OptionsGridSearchModal from "./OptionsGridSearchModal";

/**
 * @author
 * E45597 Aryamitra Chaudhuri
 */

interface OptionsGridWrapperProps extends RouteProps {
  userCMEDEntitlements: CMEDPermissions | undefined;
  // persistedOption: boolean;
  userSelectedOption?: any;
  persistedOptionGrids: any;
  setPersistedOptionGrids: any;
  setdeletedOptionGridIndex: any;
  greekType: any;
  setgreekType: Function;
  setselectedOption_Super: any;
  optionsGridGroup: any;
  setOptionsGridGroup: any;
  optionGrids: any;
  setOptionsList: Function;
  returnToOptionGrid: () => void;
}
const OptionsGridWrapper: React.FC<OptionsGridWrapperProps> = ({
  userCMEDEntitlements,
  userSelectedOption,
  persistedOptionGrids,
  setPersistedOptionGrids,
  setdeletedOptionGridIndex,
  greekType,
  setgreekType,
  setselectedOption_Super,
  optionGrids,
  setOptionsList,
  returnToOptionGrid,
}) => {
  const [isMidStrikeValue, setIsMidStrikeValue] = useState<number>();

  const [isOptionsGridSearchModalOpen, setIsOptionsGridSearchModalOpen] =
    useState<boolean>(false);
  const [isOptionItemClicked, setIsOptionItemClicked] = useState<boolean>(
    userSelectedOption != null,
  );
  const [isOptionsGridViewModalOpen, setIsOptionsGridViewModalOpen] =
    useState<boolean>(false);
  const [selectedExpiryId, setSelectedExpiryId] = useState(2);
  const [selectedOptionCheckboxes, setSelectedOptionCategoryCheckboxes] =
    useState<string[]>([]);
  const [optionsListData, setOptionsListData] = useState<{ payload: any }>({
    payload: [],
  });

  const [selectedOption, setselectedOption] = useState<any>(userSelectedOption);

  useEffect(() => {
    setselectedOption(userSelectedOption);
    setIsOptionItemClicked(userSelectedOption != null);
  }, [userSelectedOption]);

  const initialMidStrikeValue = (data: any) => {
    setIsMidStrikeValue(data.detail.value);
  };

  return (
    <>
      {!isOptionItemClicked ? (
        <OptionsGridForm // current base form
          greekType={greekType}
          setgreekType={setgreekType}
          selectedOptionCheckboxes={selectedOptionCheckboxes}
          setSelectedOptionCategoryCheckboxes={
            setSelectedOptionCategoryCheckboxes
          }
          selectedExpiryId={selectedExpiryId}
          setSelectedExpiryId={setSelectedExpiryId}
          returnToOptionGrid={returnToOptionGrid}
          hasSelectedOptions={optionGrids != null && optionGrids.length > 0}
          setOptionsListData={setOptionsListData}
          setIsOptionsGridSearchModalOpen={setIsOptionsGridSearchModalOpen}
        />
      ) : (
        <OptionsGrid // actual options grid
          setgreekType={setgreekType}
          greekType={greekType}
          isOptionsGridViewModalOpen={isOptionsGridViewModalOpen}
          setIsOptionsGridViewModalOpen={setIsOptionsGridViewModalOpen}
          selectedOption={selectedOption}
          userCMEDEntitlements={userCMEDEntitlements}
          isMidStrikeValue={isMidStrikeValue}
          persistedOptionGrids={persistedOptionGrids}
          setPersistedOptionGrids={setPersistedOptionGrids}
          setdeletedOptionGridIndex={setdeletedOptionGridIndex}
          setselectedOption_Super={setselectedOption_Super}
          optionGrids={optionGrids}
          setSelectedExpiryId={setSelectedExpiryId}
        />
      )}
      <OptionsGridSearchModal // after clicking on search to display options list
        isOptionsGridSearchModalOpen={isOptionsGridSearchModalOpen}
        setIsOptionsGridSearchModalOpen={setIsOptionsGridSearchModalOpen}
        setIsOptionItemClicked={setIsOptionItemClicked}
        optionsListData={optionsListData}
        selectOption={setOptionsList}
      />
    </>
  );
};

export default OptionsGridWrapper;
